import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { $ok } from "foundation-ts/commons";

import { TemporaryChildProps } from "@components/layouts/TemporaryAuthenticatedLayout";
import { config } from "@/config/config";
import { defaultErrorToast, defaultInfoToast, defaultSuccessToast } from "@utils/toast";

export const ConfirmNewEmailView = ({ sharedData } : TemporaryChildProps) => {
    const toast = useToast() ;
    const navigate = useNavigate();

    useEffect(() => {
        if ($ok(sharedData)) {
            toast($ok(sharedData) ? defaultSuccessToast( "Votre changement d'email a bien été pris en compte. A la prochaine connexion, c'est la nouvelle adresse mail qu'il faudra utiliser.") : defaultErrorToast("Impossible de changer votre adresse mail"));
            toast(defaultInfoToast("Vous allez être automatiquement redirigé vers la page d'authentification.")) ;
            const timer = setTimeout(() => {
                navigate(config.app.loginURL!) ;
            }, 2000) ;

            return () => clearTimeout(timer) ;
        }
    }, [sharedData]) ;

    return <></> ;
} ;